import type { SVGProps } from 'react';
const SvgRectangleSplitThirds = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Rectangle Split Thirds Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M.66 14.536V3.964c0-.73.592-1.321 1.322-1.321h14.536c.73 0 1.321.591 1.321 1.321v10.572c0 .73-.591 1.321-1.321 1.321H1.982c-.73 0-1.321-.591-1.321-1.321M6.387 2.643v13.214M12.114 2.643v13.214" />
    </g>
  </svg>
);
export default SvgRectangleSplitThirds;
